"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Input = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = require("./Input.style");

var _utils = require("../lib/utils");

var _Label = _interopRequireDefault(require("../label/Label"));

var _excluded = ["helperText", "color", "startIcon", "endIcon", "id", "error", "required", "label", "limit", "onFocus", "onBlur", "disabled", "prefix", "suffix", "className"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _helperText$props;

  var helperText = props.helperText,
      color = props.color,
      startIcon = props.startIcon,
      endIcon = props.endIcon,
      id = props.id,
      error = props.error,
      required = props.required,
      label = props.label,
      limit = props.limit,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      disabled = props.disabled,
      prefix = props.prefix,
      suffix = props.suffix,
      className = props.className,
      rest = (0, _objectWithoutProperties2["default"])(props, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var spaceProps = (0, _utils.getProps)(rest, function (key) {
    return _utils.spaceObj.includes(key);
  });
  var restProps = (0, _utils.getProps)(rest, function (key) {
    return !_utils.spaceObj.includes(key);
  });

  var startI = /*#__PURE__*/_react["default"].isValidElement(startIcon);

  var endI = /*#__PURE__*/_react["default"].isValidElement(endIcon);

  var handleFocus = function handleFocus(event) {
    setFocused(true);
    typeof onFocus === 'function' && onFocus(event);
  };

  var handleBlur = function handleBlur(event) {
    setFocused(false);
    typeof onBlur === 'function' && onBlur(event);
  };

  return /*#__PURE__*/_react["default"].createElement(_Input.StyledInputWrapper, (0, _extends2["default"])({}, spaceProps, {
    error: error,
    focused: focused,
    color: color,
    className: className
  }), /*#__PURE__*/_react["default"].isValidElement(label) && /*#__PURE__*/_react["default"].cloneElement(label), label && typeof label === 'string' && /*#__PURE__*/_react["default"].createElement(_Label["default"], {
    htmlFor: id
  }, label, required && "*"), /*#__PURE__*/_react["default"].createElement(_Input.StyledInputContainer, {
    startIcon: startI,
    endIcon: endI,
    disabled: disabled,
    focused: focused,
    error: error
  }, startIcon && /*#__PURE__*/_react["default"].createElement(_Input.StyledBoxLeft, {
    className: "eui-input-left"
  }, /*#__PURE__*/_react["default"].cloneElement(startIcon, _objectSpread({
    className: 'eui-icon-start'
  }, startIcon.props))), prefix && /*#__PURE__*/_react["default"].createElement(_Input.StyledBoxLeft, {
    className: "eui-input-prefix"
  }, prefix), /*#__PURE__*/_react["default"].createElement(_Input.StyledBoxMid, null, /*#__PURE__*/_react["default"].createElement(_Input.StyledInput, (0, _extends2["default"])({
    color: color,
    ref: ref,
    id: id,
    maxLength: limit && limit,
    startIcon: startI,
    endIcon: endI,
    onFocus: handleFocus,
    onBlur: handleBlur,
    disabled: disabled
  }, restProps))), suffix && /*#__PURE__*/_react["default"].createElement(_Input.StyledBoxRight, {
    className: "eui-input-suffix"
  }, suffix), endIcon && /*#__PURE__*/_react["default"].createElement(_Input.StyledBoxRight, {
    className: "eui-input-right"
  }, /*#__PURE__*/_react["default"].cloneElement(endIcon, _objectSpread({
    className: 'eui-icon-end'
  }, endIcon.props)))), /*#__PURE__*/_react["default"].createElement(_Input.StyledWrapper, null, /*#__PURE__*/_react["default"].createElement(_Input.StyledWrapperLeft, null, helperText && /*#__PURE__*/_react["default"].isValidElement(helperText) ? /*#__PURE__*/_react["default"].cloneElement(helperText, _objectSpread({
    color: (helperText === null || helperText === void 0 ? void 0 : (_helperText$props = helperText.props) === null || _helperText$props === void 0 ? void 0 : _helperText$props.color) || (0, _utils.getPalette)('base', 'c03'),
    className: 'eui-helper-text'
  }, helperText.props)) : helperText && /*#__PURE__*/_react["default"].createElement(_Input.HelperText, {
    className: "eui-helper-text"
  }, helperText)), limit && /*#__PURE__*/_react["default"].createElement(_Input.StyledWrapperRight, null, "".concat(props.value && props.value.length ? props.value.length : 0, "/").concat(limit))));
});

exports.Input = Input;
var INPUT_ERROR_TEXT = 'InputHelperText';

Input.HelperText = function (props) {
  return /*#__PURE__*/_react["default"].createElement(_Input.HelperText, props, props.children);
};

Input.HelperText.propTypes = {
  children: _propTypes["default"].node
};
Input.HelperText.displayName = INPUT_ERROR_TEXT;
Input.defaultProps = {
  disabled: false,
  error: false
};
Input.propTypes = {
  id: _propTypes["default"].string,
  type: _propTypes["default"].string,
  color: _propTypes["default"].string,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Icon component can be passed eg: `<Icon iconName='LeftArrow' size={24}/>`
   */
  startIcon: _propTypes["default"].node,

  /**
   * Icon component can be passed eg: `<Icon iconName='LeftArrow' size={24}/>`
   */
  endIcon: _propTypes["default"].node,
  required: _propTypes["default"].bool,
  error: _propTypes["default"].bool,
  limit: _propTypes["default"].number,

  /**
   * eg: `<Input.HelperText >This is a helper text</Input.HelperText>`
   */
  helperText: _propTypes["default"].node,
  defaultValue: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onKeyPress: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  prefix: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  suffix: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  className: _propTypes["default"].string
};
var _default = Input;
exports["default"] = _default;